import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import moment from 'moment'

import { BlueBox } from '../../../InfoBox'
import { Padding, UnstyledLink } from '../../..'
import { Body, Header, Author, Note } from './LatestNotes.style'
import { Routes } from '../../../../constants'

const LatestNotes = ({ isEmpty, loading, notes, t }) => {
    const { note, user_name: author, store_code: code, created_at: createdAtRaw } = notes[0] || {}
    const createdAt = moment(createdAtRaw).fromNow()

    return (
        <BlueBox loading={loading} noResults={isEmpty}>
            <UnstyledLink to={Routes.buildRoute(Routes['ESTATE:STORE:ID'], { code })}>
                <Padding fullHeight>
                    <Header>{t('Latest Note')}</Header>
                    <Body>
                        <Note title={note}>{note}</Note>
                        <Author>
                            {author}
                            &nbsp;
                            {createdAt}
                        </Author>
                    </Body>
                </Padding>
            </UnstyledLink>
        </BlueBox>
    )
}

LatestNotes.propTypes = {
    isEmpty: PropTypes.bool,
    loading: PropTypes.number,
    notes: PropTypes.arrayOf(
        PropTypes.shape({
            note: PropTypes.string,
            user_name: PropTypes.string,
            created_at: PropTypes.string,
        })
    ),
    t: PropTypes.func.isRequired,
}

LatestNotes.defaultProps = {
    isEmpty: true,
    loading: null,
    notes: [],
}

export default withTranslation()(LatestNotes)
